import { Box } from '@mui/material'

interface PdfPreviewProps {
  url: string
  name: string
  onError: () => void
  variant: 'card' | 'chat'
}

export const PdfPreview = ({ url, name, onError, variant }: PdfPreviewProps) => {
  const isChat = variant === 'chat'

  if (isChat) {
    return (
      <Box
        component="iframe"
        src={url}
        onError={onError}
        title={name}
        sx={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
      />
    )
  }

  return (
    <Box
      component="iframe"
      src={url}
      onError={onError}
      title={name}
      sx={{ width: '100%', height: '100%', border: 'none' }}
    />
  )
}
